// Central export and registry for modal forms used in dynamic form association

import QaQcRfiSelect from './QaQcRfiSelect';
import PersonnelSelect from './PersonnelSelect';
import PersonnelCodeSelect from './PersonnelCodeSelect';
import PersonnelNameSelect from './PersonnelNameSelect';
import CustomOptionsModal from './CustomOptionsModal';
import ActivitySelections from './ActivitySelections';
import ActivitySelectByWbsModal from './ActivitySelectByWbsModal';
import CombinedActivitySelectorModal from './CombinedActivitySelectorModal';
import GapMasterMaterialSelect from './GapMasterMaterialSelect';
import MatGapMaterialSelect from './MatGapMaterialSelect';
import MatGapMasterMaterialSelect from './MatGapMasterMaterialSelect';
import MatClntMasterMaterialSelect from './MatClntMasterMaterialSelect';
import CountrySelect from './CountrySelect';
import CurrencySelect from './CurrencySelect';
import UnitsSelect from './UnitsSelect';
import CompaniesSelect from './CompaniesSelect';
import ToCostCenterSelect from './ToCostCenterSelect';
import WPermitSelect from './WPermitSelect';
import PipeMaterialSelect from './PipeMaterialSelect';
import WeldSelectModal from './WeldSelectModal';
import PendingWeldsSelectModal from './PendingWeldsSelectModal';
import PipeHeatNoSelect from './PipeHeatNoSelect';
import WelderSelect from './WelderSelect';
import ClntPipeMatSelect from './ClntPipeMatSelect';
import SelectDCCFileModal from './SelectDCCFileModal';
import RootFolderSelect from './RootFolderSelect';
import FolderFileSearchModal from './FolderFileSearchModal';
import MachineSelect from './MachineSelect';
import ContractSelect from './ContractSelect';

// Registry for use in dropdowns, etc.
const modalRegistry = [
  { name: 'QaQcRfiSelect', component: QaQcRfiSelect },
  { name: 'PersonnelSelect', component: PersonnelSelect },
  { name: 'PersonnelCodeSelect', component: PersonnelCodeSelect },
  { name: 'PersonnelNameSelect', component: PersonnelNameSelect },
  { name: 'CustomOptionsModal', component: CustomOptionsModal },
  { name: 'ActivitySelections', component: ActivitySelections },
  { name: 'ActivitySelectByWbsModal', component: ActivitySelectByWbsModal },
  { name: 'CombinedActivitySelectorModal', component: CombinedActivitySelectorModal },
  { name: 'GapMasterMaterialSelect', component: GapMasterMaterialSelect },
  { name: 'MatGapMaterialSelect', component: MatGapMaterialSelect },
  { name: 'MatGapMasterMaterialSelect', component: MatGapMasterMaterialSelect },
  { name: 'MatClntMasterMaterialSelect', component: MatClntMasterMaterialSelect },
  { name: 'CountrySelect', component: CountrySelect },
  { name: 'CurrencySelect', component: CurrencySelect },
  { name: 'UnitsSelect', component: UnitsSelect },
  { name: 'CompaniesSelect', component: CompaniesSelect },
  { name: 'ToCostCenterSelect', component: ToCostCenterSelect },
  { name: 'WPermitSelect', component: WPermitSelect },
  { name: 'PipeMaterialSelect', component: PipeMaterialSelect },
  { name: 'WeldSelectModal', component: WeldSelectModal },
  { name: 'PendingWeldsSelectModal', component: PendingWeldsSelectModal },
  { name: 'PipeHeatNoSelect', component: PipeHeatNoSelect },
  { name: 'WelderSelect', component: WelderSelect },
  { name: 'ClntPipeMatSelect', component: ClntPipeMatSelect },
  { name: 'SelectDCCFileModal', component: SelectDCCFileModal },
  { name: 'RootFolderSelect', component: RootFolderSelect },
  { name: 'FolderFileSearchModal', component: FolderFileSearchModal },
  { name: 'MachineSelect', component: MachineSelect },
  { name: 'ContractSelect', component: ContractSelect },
];

export default modalRegistry;

// Named exports for direct imports via this index
export {
  QaQcRfiSelect,
  PersonnelSelect,
  PersonnelCodeSelect,
  PersonnelNameSelect,
  CustomOptionsModal,
  ActivitySelections,
  ActivitySelectByWbsModal,
  CombinedActivitySelectorModal,
  GapMasterMaterialSelect,
  MatGapMaterialSelect,
  MatGapMasterMaterialSelect,
  MatClntMasterMaterialSelect,
  CountrySelect,
  CurrencySelect,
  UnitsSelect,
  CompaniesSelect,
  ToCostCenterSelect,
  WPermitSelect,
  PipeMaterialSelect,
  WeldSelectModal,
  PendingWeldsSelectModal,
  PipeHeatNoSelect,
  WelderSelect,
  ClntPipeMatSelect,
  SelectDCCFileModal,
  RootFolderSelect,
  FolderFileSearchModal,
  MachineSelect,
  ContractSelect,
};
